export const state = () => ({
  addressDataStored: null,
  demographicDataStored: null,
  avatarUrlStored: null,
  securityQuestionsStored: null,
  emailStored: null,
  phoneStored: null,
  actionLoading: false,
})

export const mutations = {
  setAddress(state, data) {
    state.addressDataStored = data
  },
  setDemographicData(state, data) {
    state.demographicDataStored = data
  },
  setAvatarUrl(state, data) {
    console.log('setting avatat', data)
    state.avatarUrlStored = data
  },
  setSecurityQuestions(state, data) {
    state.securityQuestionsStored = data
  },
  setEmail(state, data) {
    state.emailStored = data
  },
  setPhone(state, data) {
    state.phoneStored = data
  },
  setActionLoading(state, data) {
    state.actionLoading = data
  },
}
